import {
  ConsentCategory,
  ConsentCategoryId,
  ConsentDecision,
  NON_ESSENTIAL_CATEGORIES,
  TC_CATEGORY_ID,
} from './categories';

export const CONSENT_MANAGER_UPDATE_EVENT =
  'consentManager.onConsentUpdated' as const;
export const CONSENT_MANAGER_SHOW_EVENT = 'consentManager.showBanner' as const;

export type ConsentStatus = 'unset' | 'on' | 'off' | 'custom';

export type ConsentState = {
  status: ConsentStatus;
  categories: ConsentCategoryId[];
};

export type ConsentManagerApi = {
  ready: boolean;
  get: () => ConsentState;
  showBanner: () => void;
};

export const getConsentState = (
  decision: ConsentDecision | null,
): ConsentState => {
  if (!decision) {
    return { status: 'unset', categories: [] };
  }

  const categories = Object.entries(TC_CATEGORY_ID)
    .filter(([category]) => decision[category as ConsentCategory])
    .map(([, id]) => id);
  const acceptedOptionalCategories = NON_ESSENTIAL_CATEGORIES.filter(
    category => decision[category],
  );

  return {
    status:
      acceptedOptionalCategories.length === NON_ESSENTIAL_CATEGORIES.length
        ? 'on'
        : acceptedOptionalCategories.length > 0
          ? 'custom'
          : 'off',
    categories,
  };
};

export const subscribeToConsentUpdates = (
  listener: (state: ConsentState) => void,
): (() => void) => {
  const onUpdate = (event: Event) => {
    listener((event as CustomEvent<ConsentState>).detail);
  };

  window.addEventListener(CONSENT_MANAGER_UPDATE_EVENT, onUpdate);

  return () =>
    window.removeEventListener(CONSENT_MANAGER_UPDATE_EVENT, onUpdate);
};

export const isConsentCategoryGranted = (
  state: ConsentState | undefined,
  category: ConsentCategory,
): boolean => state?.categories.includes(TC_CATEGORY_ID[category]) ?? false;
